import { ModelBase } from 'store/model-base';

export class SendOTP extends ModelBase {
    public static storeName: string = 'sendOTP';

    public otpSent: boolean;
    public failureReason: string;


    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: SendOTP = super.create<SendOTP>(initData);

        return super.create<T>(toReturn);
    }
}
